import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const HeaderContainer = styled.div`
  height: 71px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${Colors.background_dividers};
  padding-left: 35px;
  padding-right: 35px;
  color: ${Colors.text_primary};
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
`;

const CloseButtonWrapper = styled.div`
  cursor: pointer;
`;

const SaveTextWrapper = styled.div`
  color: ${Colors.text_primary};
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  ${(props) => !props.enable && 'opacity: 0.3;'}
  cursor: pointer;
`;

const BodyWrapper = styled.div`
  padding: 40px 62.5px 10px 65px;
  height: 472px;
  display: flex;
  flex-direction: row;
  @media (max-width: 1017px) {
    flex-direction: column;
  }
`;

const Title = styled.div`
  margin-bottom: 18px;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: ${Colors.text_primary};
`;

const Line = styled.div`
  background: ${Colors.background_dividers};
  margin-bottom: 10px;
  height: 1px;
`;

const ColorWrapper = styled.div`
  border-radius: 5px;
  margin-bottom: 16px;
  display: grid;
  align-items: center;
  width: 211px;
  height: 116.29px;
  place-content: center;

  ${(props) =>
    (props.color
      ? `background: ${props.color};`
      : `border: 1px solid ${Colors.background_dividers};`)}
`;

const LeftContainer = styled.div`
  width: 583px;
  @media (max-width: 1017px) {
    width: 100%;
  }
  margin-right: 84px;
`;

const SubTitle = styled.div`
  color: ${Colors.text_primary};
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 8px;
`;

export default {
  HeaderContainer,
  CloseButtonWrapper,
  SaveTextWrapper,
  BodyWrapper,
  Title,
  Line,
  ColorWrapper,
  LeftContainer,
  SubTitle,
};
